import Vue from 'vue';
import App from './App.vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';

// ===== IGNORER LES ERREURS RESIZE OBSERVER =====
// 1. Ignorer globalement dans Vue
const originalErrorHandler = Vue.config.errorHandler;
Vue.config.errorHandler = function(err, vm, info) {
    if (err && err.message && 
        (err.message.includes('ResizeObserver') || 
         err.message.includes('ResizeObserver loop completed with undelivered notifications'))) {
        return; // Ignorer silencieusement
    }
    if (originalErrorHandler) {
        originalErrorHandler(err, vm, info);
    } else {
        console.error(err);
    }
};

// 2. Ignorer les erreurs globales window
window.addEventListener('error', function(e) {
    if (e.message && e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
});

// 3. Ignorer les promesses rejetées
window.addEventListener('unhandledrejection', function(e) {
    if (e.reason && e.reason.message && 
        e.reason.message.includes('ResizeObserver loop completed with undelivered notifications')) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
});

// ===== CONFIGURATION DE PRODUCTION =====
Vue.config.productionTip = false;

// ===== AG-GRID ENTERPRISE =====
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';

// Licence AG-Grid
LicenseManager.setLicenseKey("For_Production-Valid_Until-22_May_2024_[v29]_MTYyMTYzODAwMDAwMA==edd463c08734ce415741e4c2b8ade1f5");

// ===== BOOTSTRAP VUE =====
import { ModalPlugin, BOverlay, BTab, BTabs, BFormFile } from 'bootstrap-vue';

// Enregistrement des composants Bootstrap
Vue.component('BOverlay', BOverlay);
Vue.component('BTab', BTab);
Vue.component('BTabs', BTabs);
Vue.component('BFormFile', BFormFile);

// Utilisation du plugin Modal
Vue.use(ModalPlugin);

// ===== TOAST NOTIFICATION =====
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

Vue.use(Toast, {
    // Options de configuration
    position: 'top-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: 'button',
    icon: true,
    rtl: false
});

// ===== CKEDITOR =====
Vue.use(CKEditor);

// ===== AXIOS =====
import axios from '@/libs/axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

// ===== ROUTER & STORE =====
import router from './router';
import store from './store';

// ===== FONT AWESOME =====
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

// ===== TOASTIFICATION PERSONNALISÉE =====
import '@/libs/toastification';

// ===== PERFORMANCE OPTIMISATION =====
// Désactiver les logs en production
if (process.env.NODE_ENV === 'production') {
    console.log = function() {};
    console.warn = function() {};
    // Garder les erreurs pour le débogage
    // console.error = function() {};
}

// ===== CRÉATION DE L'INSTANCE VUE =====
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');